import { render } from "./InvestigationProcedure.vue?vue&type=template&id=29e41973&scoped=true"
import script from "./InvestigationProcedure.vue?vue&type=script&lang=js"
export * from "./InvestigationProcedure.vue?vue&type=script&lang=js"

import "./InvestigationProcedure.vue?vue&type=style&index=0&id=29e41973&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e41973"]])

export default __exports__